<template>
    <div
        class="rotator-holder"
        v-if="store.state.currentMode.name === 'rotate'"
        @pointerdown="startRotation"
        @pointerup="rotating=false"
        @pointermove="processMove"
    >
        <div class="donut"></div>
        <div class="handle" :style="handleStyle" @pointerdown="reset"></div>
    </div>
</template>

<script>
import { settings } from '../myapp/src/settings';
import { utils } from '../myapp/src/utils';
export default {
    data() {
        return {
            rotating: false,
            startingAngle: 0,
            currentAngle: 0
        }
    },
    methods: {
        initialize() {
            this.startingAngle = game.cameras.main.rotation;
            this.currentAngle = game.cameras.main.rotation;
        },
        getAngle(evt) {
            const x = evt.clientX - (window.innerWidth / 2);
            const y = evt.clientY - (window.innerHeight / 2);
            return - 1 * utils.myArcTan(x, y);
        },
        startRotation(evt) {
            this.rotating = true;
            const a = this.getAngle(evt);
            this.startingAngle = a - game.cameras.main.rotation;
            this.currentAngle = game.cameras.main.rotation;
        },
        processMove(evt) {
            if (!this.rotating) return;
            const a = this.getAngle(evt);
            const _a = a - this.startingAngle;

            game.cameras.main.setRotation(_a);
            this.currentAngle = game.cameras.main.rotation;
        },
        reset() {
            const a = settings.pattern.rotateCamera ? Math.PI / 2 : 0;
            game.cameras.main.setRotation(a);
            this.currentAngle = game.cameras.main.rotation;
        },
        rotateLeft() {
            const a = game.cameras.main.rotation - (Math.PI / 2);
            game.cameras.main.setRotation(a);
            this.currentAngle = game.cameras.main.rotation;
        },
        rotateRight() {
            const a = game.cameras.main.rotation + (Math.PI / 2);
            game.cameras.main.setRotation(a);
            this.currentAngle = game.cameras.main.rotation;
        },
    },
    computed: {
        handleStyle: function () {

            const a = settings.pattern.rotateCamera ? 0 : Math.PI / 2;

            const top = 60 + (Math.sin(this.currentAngle + a) * 155);
            const left = 0 + (Math.cos(this.currentAngle + a) * 155);
            return `top: calc(50vh - ${top}px); left: calc(50vw - ${left}px);`;
        }
    },
    mounted() {
        this.ee.on('initializeRotator', () => this.initialize());
        this.ee.on('rotateLeft', () => this.rotateLeft());
        this.ee.on('rotateRight', () => this.rotateRight());

    }
}
</script>

<style lang="scss">
@import '../assets/colors.scss';
.rotator-holder {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    .donut {
        width: 300px;
        height: 300px;
        border: 10px solid white;
        border-radius: 100%;
        z-index: 1;
        position: absolute;
        top: calc(50vh - 210px);
        left: calc(50vw - 150px);
    }
    .handle {
        width: 20px;
        height: 20px;
        background-color: black;
        border-radius: 100%;
        border: 1px solid white;
        z-index: 1;
        position: absolute;
        &:hover {
            background-color: $b_theme;
            cursor: pointer;
        }
    }
}
.rotating {
    background-color: green;
}
</style>